module.exports = __webpack_public_path__ + "static/media/stone.50decbcb.png";